module.exports = __webpack_public_path__ + "img/1.df95f4a8.jpg";